export enum TipoEstornoContaEnum {
    AutomaticoAoCancelarPedido = 1,
    AutomaticoAoCancelarPedidoOuNotaFiscal = 2
}
